const TaskStandard = React.memo(function TaskStandard(props){
    const {} = props;

    //useRenderDebug('TaskStandard', {props});

    return null;
});

TaskStandard.defaultProps = {

};

TaskStandard.defaultProps = {

};
TaskStandard.displayName = 'TaskStandard';